import {Component} from '@angular/core';
import {ListViewItem} from '@domain/common/list-view/list-view-item';
import {Relance} from '@domain/relance/relance';
import {ConfirmService} from '@share/component/confirmation/confirm.service';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {first} from 'rxjs/operators';
import {TypeCodeErreur} from '@domain/common/http/result';
import {NotificationRelancesService} from '../notification-relances.service';
import {Router} from "@angular/router";

/**
 * Composant pour afficher une relance dans la liste des relances
 */
@Component({
    selector: 'relance-list-item',
    templateUrl: './relance-list-item.component.html'
})
export class RelanceListItemComponent extends ListViewItem<Relance> {

    /**
     * Constructeur
     *
     * @param notificationRelancesService Service de notification relances
     * @param confirmService Service de confirmation
     * @param translateService  Service de traduction
     * @param toastrService     Service de notification
     * @param router
     */
    constructor(private notificationRelancesService: NotificationRelancesService,
                private confirmService: ConfirmService,
                private translateService: TranslateService,
                private toastrService: ToastrService,
                private router: Router) {
        super();
    }

    /**
     * Navigue au détail de la relance
     */
    goToDetailRelance(): void {
        this.router.navigate(['/Admin/Bibliotheque/Notification/Relances', this.data.idRelance]);
    }


    /**
     * Supprime la relance courante après confirmation utilisateur.
     */
    deleteRelance(): void {
        //Demande de confirmation avant suppression
        this.confirmService.showConfirm(this.translateService.instant('global.suppression.confirmation'))
            .pipe(first())
            .subscribe(isConfirmed => {
                //Sort si l’utilisateur annule
                if (!isConfirmed) {
                    return;
                }

                //Appel de suppression
                this.notificationRelancesService.deleteRelance({idRelance: this.data.idRelance} as any)
                    .pipe(first())
                    .subscribe(result => {
                        //Cas OK : suppression effectuée
                        if (result?.codeErreur === TypeCodeErreur.NO_ERROR) {
                            this.toastrService.success(this.translateService.instant('global.success.suppression'));

                            //Rafraîchit la liste
                            this.liste?.refresh?.();
                        } else {
                            //Toast d'erreur
                            TypeCodeErreur.showError(result?.codeErreur, this.translateService, this.toastrService);
                        }
                    });
            });
    }
}